<template>
<div class="wordhomw-wrap">
  <div  class="v-note-wrapper markdown-body shadow"><h2><a ></a>组件库</h2>
    <ul>
      <li><a href="#">用户</a></li>
      <li><a href="#">部门</a></li>
      <li><a href="#">角色</a></li>
      <li><a href="#">岗位</a></li>
      <li><a href="#">文件上传</a></li>
      <li><a href="#">图片上传</a></li>
      <li><a href="#">图片选择</a></li>
    </ul>
  </div>

</div>
</template>

<script>
export default {
  name: "wordCom23"
}
</script>

<style scoped>

</style>
